/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { Gacha } from '../Gacha/Common/Gacha'
import { GachaBonus } from '../Gacha/Common/GachaBonus'
import { GachaRarityGuarantee } from '../Gacha/Common/GachaRarityGuarantee'

export const protobufPackage = 'Reality.Reality.Api'

/**
 * <strong>GET /api/v2/gacha/list</strong>
 * 引けるガチャの一覧を取得する
 */
export interface GachaListResponse {
  gachaList: Gacha[]
  gachaBonusList: GachaBonus[]
  userDrawCountByGroupList: GachaDrawCountByGroup[]
  /** 未確定の色変更アイテムが存在するかどうか */
  hasUndetermined: boolean
  gachaRarityGuaranteeList: GachaRarityGuarantee[]
}

export interface GachaDrawCountByGroup {
  /** ガチャグループID */
  groupId: string
  /** このグループでのガチャ回転数 */
  count: number
}

function createBaseGachaListResponse(): GachaListResponse {
  return {
    gachaList: [],
    gachaBonusList: [],
    userDrawCountByGroupList: [],
    hasUndetermined: false,
    gachaRarityGuaranteeList: [],
  }
}

export const GachaListResponse = {
  encode(
    message: GachaListResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.gachaList) {
      Gacha.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    for (const v of message.gachaBonusList) {
      GachaBonus.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    for (const v of message.userDrawCountByGroupList) {
      GachaDrawCountByGroup.encode(v!, writer.uint32(26).fork()).ldelim()
    }
    if (message.hasUndetermined === true) {
      writer.uint32(32).bool(message.hasUndetermined)
    }
    for (const v of message.gachaRarityGuaranteeList) {
      GachaRarityGuarantee.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaListResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaListResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.gachaList.push(Gacha.decode(reader, reader.uint32()))
          break
        case 2:
          message.gachaBonusList.push(
            GachaBonus.decode(reader, reader.uint32())
          )
          break
        case 3:
          message.userDrawCountByGroupList.push(
            GachaDrawCountByGroup.decode(reader, reader.uint32())
          )
          break
        case 4:
          message.hasUndetermined = reader.bool()
          break
        case 5:
          message.gachaRarityGuaranteeList.push(
            GachaRarityGuarantee.decode(reader, reader.uint32())
          )
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaListResponse {
    return {
      gachaList: Array.isArray(object?.gachaList)
        ? object.gachaList.map((e: any) => Gacha.fromJSON(e))
        : [],
      gachaBonusList: Array.isArray(object?.gachaBonusList)
        ? object.gachaBonusList.map((e: any) => GachaBonus.fromJSON(e))
        : [],
      userDrawCountByGroupList: Array.isArray(object?.userDrawCountByGroupList)
        ? object.userDrawCountByGroupList.map((e: any) =>
            GachaDrawCountByGroup.fromJSON(e)
          )
        : [],
      hasUndetermined: isSet(object.hasUndetermined)
        ? Boolean(object.hasUndetermined)
        : false,
      gachaRarityGuaranteeList: Array.isArray(object?.gachaRarityGuaranteeList)
        ? object.gachaRarityGuaranteeList.map((e: any) =>
            GachaRarityGuarantee.fromJSON(e)
          )
        : [],
    }
  },

  toJSON(message: GachaListResponse): unknown {
    const obj: any = {}
    if (message.gachaList) {
      obj.gachaList = message.gachaList.map((e) =>
        e ? Gacha.toJSON(e) : undefined
      )
    } else {
      obj.gachaList = []
    }
    if (message.gachaBonusList) {
      obj.gachaBonusList = message.gachaBonusList.map((e) =>
        e ? GachaBonus.toJSON(e) : undefined
      )
    } else {
      obj.gachaBonusList = []
    }
    if (message.userDrawCountByGroupList) {
      obj.userDrawCountByGroupList = message.userDrawCountByGroupList.map((e) =>
        e ? GachaDrawCountByGroup.toJSON(e) : undefined
      )
    } else {
      obj.userDrawCountByGroupList = []
    }
    message.hasUndetermined !== undefined &&
      (obj.hasUndetermined = message.hasUndetermined)
    if (message.gachaRarityGuaranteeList) {
      obj.gachaRarityGuaranteeList = message.gachaRarityGuaranteeList.map((e) =>
        e ? GachaRarityGuarantee.toJSON(e) : undefined
      )
    } else {
      obj.gachaRarityGuaranteeList = []
    }
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaListResponse>, I>>(
    object: I
  ): GachaListResponse {
    const message = createBaseGachaListResponse()
    message.gachaList = object.gachaList?.map((e) => Gacha.fromPartial(e)) || []
    message.gachaBonusList =
      object.gachaBonusList?.map((e) => GachaBonus.fromPartial(e)) || []
    message.userDrawCountByGroupList =
      object.userDrawCountByGroupList?.map((e) =>
        GachaDrawCountByGroup.fromPartial(e)
      ) || []
    message.hasUndetermined = object.hasUndetermined ?? false
    message.gachaRarityGuaranteeList =
      object.gachaRarityGuaranteeList?.map((e) =>
        GachaRarityGuarantee.fromPartial(e)
      ) || []
    return message
  },
}

function createBaseGachaDrawCountByGroup(): GachaDrawCountByGroup {
  return { groupId: '', count: 0 }
}

export const GachaDrawCountByGroup = {
  encode(
    message: GachaDrawCountByGroup,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.groupId !== '') {
      writer.uint32(10).string(message.groupId)
    }
    if (message.count !== 0) {
      writer.uint32(16).int64(message.count)
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): GachaDrawCountByGroup {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaDrawCountByGroup()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.groupId = reader.string()
          break
        case 2:
          message.count = longToNumber(reader.int64() as Long)
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaDrawCountByGroup {
    return {
      groupId: isSet(object.groupId) ? String(object.groupId) : '',
      count: isSet(object.count) ? Number(object.count) : 0,
    }
  },

  toJSON(message: GachaDrawCountByGroup): unknown {
    const obj: any = {}
    message.groupId !== undefined && (obj.groupId = message.groupId)
    message.count !== undefined && (obj.count = Math.round(message.count))
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaDrawCountByGroup>, I>>(
    object: I
  ): GachaDrawCountByGroup {
    const message = createBaseGachaDrawCountByGroup()
    message.groupId = object.groupId ?? ''
    message.count = object.count ?? 0
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
